// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/fonts/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/fonts/Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/fonts/Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/fonts/Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/fonts/Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
div,
p,
h1,
h2,
h3,
h4,
ul,
li,
span,
form,
input,
select,
button {
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 700;
  font-style: normal;
}
body {
  color: #343a41;
  background: #fff;
  font-family: "Inter", sans-serif;
  font-size: 16px;
}
.ant-checkbox input,
.ant-radio input {
  left: -8px !important;
  top: -8px !important;
  width: 32px !important;
  height: 32px !important;
}
`, "",{"version":3,"sources":["webpack://./src/style.less"],"names":[],"mappings":"AAEA;;;;;;;;;;;;;;;EAeE,SAAA;EACA,UAAA;AADF;AAIA;EACE,oBAAA;EACA,oHAAA;EAGA,gBAAA;EACA,kBAAA;AAJF;AAOA;EACE,oBAAA;EACA,oHAAA;EAGA,gBAAA;EACA,kBAAA;AAPF;AAUA;EACE,oBAAA;EACA,oHAAA;EAGA,gBAAA;EACA,kBAAA;AAVF;AAaA;EACE,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,eAAA;AAXF;AAeA;;EAGI,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;AAdJ","sourcesContent":["@import \"./variables.less\";\n\nhtml,\nbody,\ndiv,\np,\nh1,\nh2,\nh3,\nh4,\nul,\nli,\nspan,\nform,\ninput,\nselect,\nbutton {\n  margin: 0;\n  padding: 0;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src:\n    url(\"/src/fonts/Inter-Regular.woff2\") format(\"woff2\"),\n    url(\"/src/fonts/Inter-Regular.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src:\n    url(\"/src/fonts/Inter-Medium.woff2\") format(\"woff2\"),\n    url(\"/src/fonts/Inter-Medium.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  src:\n    url(\"/src/fonts/Inter-Bold.woff2\") format(\"woff2\"),\n    url(\"/src/fonts/Inter-Bold.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n}\n\nbody {\n  color: @text-main;\n  background: @fill-main;\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n}\n\n// Увеличение кликабельной области для Checkbox, Radio\n.ant-checkbox,\n.ant-radio {\n  input {\n    left: -8px !important;\n    top: -8px !important;\n    width: 32px !important;\n    height: 32px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
